module.exports = __webpack_public_path__ + "img/1970East-010_WEB-min.d9d74eff.jpg";